import { ROLE_TYPE } from '../constants';

export const ROUTES_PATH_CONFIG = {
    COMPANY: {
        dashboard: "/c/dashboard",
        profile: "/c/profile",
        change_password: "/c/change-password",
        users: "/c/users",
        contractors: "/c/contractors",
        rfq: "/c/rfq",
        work_posts: "/c/work_posts",
        meeting_schedules: "/c/meeting_schedules",
        subscription: "/c/subscription"
    },
    VENDOR: {
        dashboard: "/v/dashboard",
        profile: "/v/profile",
        rates: "/v/rates",
        all_posts: "/v/posts/recommended",
        applied_posts: "/v/posts/applied",
        rfqs: "/v/rfqs",
        meeting_invites: "/v/meeting_invites",
        subscription: "/v/subscription"
    },
    CANDIDATE: {
        dashboard: "/cd/dashboard",
        profile: "/cd/profile",
    },
    APP: {
        signin: "/signin",
        redirect_signin: "/portal/signin",
        register: "/register",
        forgot_password: "/forgot-password",
        signout: "/signout"
    }
}

export const AUTH_REDIRECT_ROUTES = {
    ROLES: {
        [ROLE_TYPE.COMPANY]:
        {
            default: ROUTES_PATH_CONFIG.COMPANY.dashboard,
            profile: ROUTES_PATH_CONFIG.COMPANY.profile,
        },
        [ROLE_TYPE.COMPANY_CONTRACTS]: {
            default: ROUTES_PATH_CONFIG.COMPANY.dashboard,
        },
        [ROLE_TYPE.COMPANY_HR]: {
            default: ROUTES_PATH_CONFIG.COMPANY.dashboard,
        },
        [ROLE_TYPE.VENDOR]: {
            default: ROUTES_PATH_CONFIG.VENDOR.dashboard,
            profile: ROUTES_PATH_CONFIG.VENDOR.profile
        },
        [ROLE_TYPE.CANDIDATE]: {
            default: ROUTES_PATH_CONFIG.CANDIDATE.dashboard,
            profile: ROUTES_PATH_CONFIG.CANDIDATE.profile
        }
    }
}


export const AUTH_ROUTES_PATH = {
    PATHS: {
        [ROUTES_PATH_CONFIG.COMPANY.dashboard]: [ROLE_TYPE.COMPANY,
        ROLE_TYPE.COMPANY_CONTRACTS,
        ROLE_TYPE.COMPANY_HR],

        [ROUTES_PATH_CONFIG.COMPANY.subscription]: [ROLE_TYPE.COMPANY],

        [ROUTES_PATH_CONFIG.COMPANY.profile]: [ROLE_TYPE.COMPANY,
        ROLE_TYPE.COMPANY_CONTRACTS,
        ROLE_TYPE.COMPANY_HR],

        [ROUTES_PATH_CONFIG.COMPANY.contractors]: [ROLE_TYPE.COMPANY,
        ROLE_TYPE.COMPANY_CONTRACTS],
        [ROUTES_PATH_CONFIG.COMPANY.rfq]: [ROLE_TYPE.COMPANY,
        ROLE_TYPE.COMPANY_CONTRACTS],
        [ROUTES_PATH_CONFIG.COMPANY.work_posts]: [ROLE_TYPE.COMPANY,
        ROLE_TYPE.COMPANY_CONTRACTS],
        [ROUTES_PATH_CONFIG.COMPANY.meeting_schedules]: [ROLE_TYPE.COMPANY,
        ROLE_TYPE.COMPANY_CONTRACTS],


        [ROUTES_PATH_CONFIG.COMPANY.users]: [ROLE_TYPE.COMPANY],

        [ROUTES_PATH_CONFIG.VENDOR.dashboard]: [ROLE_TYPE.VENDOR],

        [ROUTES_PATH_CONFIG.VENDOR.profile]: [ROLE_TYPE.VENDOR],
        [ROUTES_PATH_CONFIG.VENDOR.subscription]: [ROLE_TYPE.VENDOR],
        [ROUTES_PATH_CONFIG.VENDOR.rates]: [ROLE_TYPE.VENDOR],
        [ROUTES_PATH_CONFIG.VENDOR.all_posts]: [ROLE_TYPE.VENDOR],
        [ROUTES_PATH_CONFIG.VENDOR.applied_posts]: [ROLE_TYPE.VENDOR],
        [ROUTES_PATH_CONFIG.VENDOR.rfqs]: [ROLE_TYPE.VENDOR],
        [ROUTES_PATH_CONFIG.VENDOR.meeting_invites]: [ROLE_TYPE.VENDOR],

        [ROUTES_PATH_CONFIG.CANDIDATE.dashboard]: [ROLE_TYPE.CANDIDATE],

        [ROUTES_PATH_CONFIG.CANDIDATE.profile]: [ROLE_TYPE.CANDIDATE]
    }
}